import { useEffect } from "react";
import { useSelector } from "react-redux";
import TrakingMap from "../../../component/admin/TrakingMap";
import { useGetActiveTripsQuery } from "../../../store/api/trackingSlice";
import { getToken } from "../../../utils/localStorageMethods";
import { socket } from "../../../utils/socket";
import { useTranslation } from "react-i18next";

const Tracking = () => {
  const { t } = useTranslation();
  const { data, isLoading, error } = useGetActiveTripsQuery();
  const user = useSelector((state) => state.UserReducer?.user);

  // Connect socket for real-time tracking
  useEffect(() => {
    const token = getToken();
    if (token && !socket.connected) {
      socket.auth = { token };
      socket.connect();
    }

    return () => {
      // Don't disconnect socket globally - other features may use it
    };
  }, []);

  const activeTrips = data?.data?.active_trips || [];

  if (isLoading) {
    return (
      <div className="tMap">
        <div
          className="d-flex align-items-center justify-content-center"
          style={{ height: "400px" }}
        >
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">{t("loading")}...</span>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="tMap">
        <div
          className="d-flex align-items-center justify-content-center"
          style={{ height: "400px" }}
        >
          <div className="text-center">
            <p className="text-danger mb-2">{t("failedToLoadActiveTrips")}</p>
            <small className="text-muted">
              {error?.data?.message || "Please try again later"}
            </small>
          </div>
        </div>
      </div>
    );
  }

  if (activeTrips.length === 0) {
    return (
      <div className="tMap">
        <div
          className="d-flex align-items-center justify-content-center"
          style={{ height: "400px" }}
        >
          <div className="text-center">
            <h5 className="text-muted mb-2"> {t("noActiveTrips")}</h5>
            <small className="text-muted">{t("noActiveTripsDesc")}</small>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="tMap">
      <div className="d-flex flex-wrap" style={{ gap: "10px" }}>
        {activeTrips.map((trip) => (
          <div
            key={trip.instance_id}
            className="flex-grow-1 p-2 position-relative z-1 map-item"
          >
            <TrakingMap trip={trip} currentUserId={user?.id} currentUserRole={user?.role} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Tracking;
